import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isNull, get, find } from 'lodash';
import {
	FormGroup, FormControl, ControlLabel,
} from 'react-bootstrap';
import { OrganizationService } from '@services';
import utils, { constants } from '@utils';
import { ProgressButton } from '@components';

class TaxExempt extends Component {
	constructor(props) {
		super(props);

		this.state = {
			document    : null,
			validation  : null,
			status      : null,
			buttonState : '',
		};

		this.initialState = this.state;
	}

	componentDidMount = () => {
		this.getOrganization();
	}

	getTagClass = (status) => {
		const statusType = find(constants.TAX_EXEMPTION_TYPES, ['countKey', status]);
		return `label-${get(statusType, ['color'], 'default')}`;
	}

	getOrganization = () => {
		const { user } = this.props;
		OrganizationService.getById(user.Organization.Id)
			.then(({ data }) => {
				let status = null;

				const { TaxExemptionRequest } = data;

				if (TaxExemptionRequest && !isNull(TaxExemptionRequest)) {
					status = 'Pending';

					if (!isNull(TaxExemptionRequest.Approved)) status = TaxExemptionRequest.Approved ? 'Approved' : 'Denied';
				}

				this.setState({
					...this.initialState,
					status,
				});
			})
			.catch(() => {
				utils.notify({
					title   : 'Error',
					type    : 'error',
					message : 'Error getting organization',
				});

				this.updateProgressButton('error');
			});
	}

	handleDocument = (event) => {
		if (!event || !event.target.files) return;

		this.setState({
			document : event.target.files[0],
		});
	}

	onSave = () => {
		const { document } = this.state;

		if (!document) {
			this.setState({ validation : 'error' }, () => {
				this.updateProgressButton('error');
			});

			return;
		}

		this.setState({ validation : null }, () => {
			this.updateProgressButton('loading');
		});

		OrganizationService.uploadTaxExemptionDocument(document)
			.then(() => {
				utils.notify({
					type    : 'success',
					message : 'Document uploaded successfully',
				});

				this.updateProgressButton('success', this.getOrganization);
			})
			.catch(() => {
				utils.notify({
					title   : 'Error',
					type    : 'error',
					message : 'Error uploading document',
				});

				this.updateProgressButton('error');
			});
	}

	updateProgressButton = (value, callback) => {
		utils.updateProgressButton({
			context  : this,
			property : 'buttonState',
			value,
			callback,
		});
	}

	render() {
		const {
			validation,
			status,
			buttonState,
		} = this.state;

		const { setRef } = this.props;

		return (
			<div
				className="card-section"
				ref={(ref) => setRef(ref)}
			>
				<div className="flex flex-align-items-center margin-bottom-20 ">
					<div className="color-dark font-bold font-size-14 flex-auto">Tax Exemption</div>
				</div>
				<If condition={status}>
					<div className={`display-inline-block margin-bottom-15 label ${this.getTagClass(status)}`}>{ status }</div>
					<Choose>
						<When condition={status === 'Pending'}>
							<p>Your application for tax exempt status is currently under review.</p>
						</When>
						<When condition={status === 'Approved' || status === 'Denied'}>
							<p>
								{`Your application for tax exempt status has been ${status.toLowerCase()}.`}
							</p>
						</When>
					</Choose>
				</If>
				<If condition={status === 'Approved'}>
					<p>If you would like to update your tax documentation, please do so below.</p>
				</If>
				<If condition={status === 'Denied' || status === null}>
					<p>To apply for tax exempt status, please upload your documentation.</p>
				</If>
				<FormGroup validationState={validation}>
					<FormControl
						name="upload-tax-exempt-file"
						type="file"
						accept=".pdf,.png,.jpg"
						className="margin-top-15"
						onChange={this.handleDocument}
					/>
					<If condition={validation === 'error'}>
						<ControlLabel>Please upload a valid document.</ControlLabel>
					</If>
				</FormGroup>
				<div className="width-all text-right margin-top-15">
					<ProgressButton
						type="submit"
						className="btn btn-primary height-42"
						text="Save"
						onClick={this.onSave}
						state={buttonState}
					/>
				</div>
			</div>
		);
	}
}

const mapStateToProps = ({
	app : { user },
}) => ({
	user,
});

TaxExempt.propTypes = {
	setRef : PropTypes.func.isRequired,
	user   : PropTypes.object,
};

TaxExempt.defaultProps = {
	user : {},
};

export default connect(mapStateToProps)(TaxExempt);
